export default __webpack_public_path__ + "static/media/TTAAgencyWelcomeTextLogo.9192fdeb.svg";